import { Api } from 'models/services/api';
import { CreateIngredientItemsQuery } from 'models/services/graphql';
import { IngredientItemData, IngredientItemEditorDataToCreate } from 'models/entities/ingredient-item';

type DataToCreate = {
  businessId: string;
  input: IngredientItemEditorDataToCreate[];
};

const RequestQuery = `
  mutation ImportIngredientItems($businessId: ID!, $input: [CreateIngredientItemInput!]!) {
    ${CreateIngredientItemsQuery}
  }
`;

type ResponseData = {
  data: {
    createIngredientItems: IngredientItemData[]
  }
}

class CreateGql {

  readonly api: Api<ResponseData>;
  readonly documents?: IngredientItemData[];

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToCreate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const documents = api.response.data.createIngredientItems;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, documents });
  }

}

export { CreateGql };